var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#121212",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1764_238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 25C24.6059 23.7108 26.6659 20.9092 26.6659 17.5C26.6659 14.0908 24.6059 11.2892 21.6667 10V11.6667C23.6559 12.8217 24.9992 15.0392 24.9992 17.5C24.9992 19.9608 23.6559 22.1783 21.6667 23.3333V25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 13.3334V21.6667C22.6875 20.7501 23.3333 18.9759 23.3333 17.5001C23.3333 16.0242 22.6875 14.2501 21.6667 13.3334ZM11.6667 21.6667H13.9142L18.7042 24.8601C18.8298 24.9435 18.9757 24.9914 19.1263 24.9988C19.277 25.0061 19.4268 24.9726 19.56 24.9017C19.693 24.8305 19.8042 24.7245 19.8817 24.5951C19.9592 24.4656 20.0001 24.3176 20 24.1667V10.8334C19.9999 10.6827 19.959 10.5348 19.8815 10.4055C19.804 10.2762 19.6929 10.1703 19.56 10.0992C19.4271 10.028 19.2774 9.99424 19.1268 10.0014C18.9763 10.0086 18.8305 10.0565 18.705 10.1401L13.9142 13.3334H11.6667C10.7475 13.3334 10 14.0809 10 15.0001V20.0001C10 20.9192 10.7475 21.6667 11.6667 21.6667ZM11.6667 15.0001H14.1667C14.1942 15.0001 14.2175 14.9867 14.2442 14.9842C14.355 14.9729 14.4626 14.9401 14.5608 14.8876C14.5825 14.8751 14.6083 14.8734 14.6292 14.8601L18.3333 12.3901V22.6101L14.6292 20.1401C14.6083 20.1259 14.5825 20.1234 14.5608 20.1126C14.4624 20.059 14.3541 20.0261 14.2425 20.0159C14.2158 20.0134 14.1933 20.0001 14.1667 20.0001H11.6667V15.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1764_238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 15,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeActive);
export default __webpack_public_path__ + "static/media/volume-active.e85e43554c2fd69b8082dbfcdd7238ff.svg";
export { ForwardRef as ReactComponent };